import AnalyticsNavigation from './AnalyticsNavigation.component';

export default AnalyticsNavigation;
